/*

? First, let's import the interface that will describe the shape of our boost object.

*/

import StateInterface from "../state-interface";

export const ai_boost_google_campaign: StateInterface["ai_boost_google_campaign"] = {
	_id: "",
	boost_id: "",
	property_id: "",
	campaign_resource_name: "",
	campaign_name: "",
	campaign_type: "",
	status: "",
	bidding_strategy: "",
	bidding_strategy_value: 0,
	daily_budget: 0,
	budget_resource_name: "",
	locations: [],
	mcp_stage: "",
	mcp_status: "",
	is_deleted: false,
	deleted_at: new Date().toISOString(),
	created_at: new Date().toISOString(),
	updated_at: new Date().toISOString(),
	last_optimized_at: new Date().toISOString(),
	last_optimization_remarks: "",
};
